

























import { Component, Vue, Prop } from 'vue-property-decorator';
import $ from 'jquery';

@Component
export default class NodeLabel extends Vue {
  @Prop()
  public text!: string;
  @Prop()
  private maxWidth!: number;

  private height: number = 0;

  get styles() {
    return {
      'top': -this.height + 'px',
      'max-width': this.maxWidth + 'px',
    };
  }

  private mounted() {
    this.height = $(this.$el).outerHeight() as number;
  }
}
